import { render, staticRenderFns } from "./AliasDetail.vue?vue&type=template&id=11e4efdb&scoped=true&"
import script from "./AliasDetail.vue?vue&type=script&lang=js&"
export * from "./AliasDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4efdb",
  null
  
)

export default component.exports